import React from 'react';
import AllocationChart from './Charts/AllocationChart';

const AllocationsSection = ({ model }) => {
    const allocations = model?.annuityFIAValues?.allocations || [];

    // Transform allocations into chart-friendly format
    const chartData = allocations.map(allocation => ({
        name: allocation.allocationName,
        value: allocation.allocationPercent,
        description: allocation.allocationDesc
    }));

    return (
        <AllocationChart chartData={chartData} />
    );
};

export default AllocationsSection;